const state = {
  loading: false
};

const getters = {
  isLoading: state => state.loading
};

const actions = {
  loading: (store, val) => {
    store.commit('setLoading', val)
  },
};

const mutations = {
  setLoading(state, value) {
    state.loading = value
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
